import { createFeatureSelector, createSelector } from '@ngrx/store';
import { LeadsState } from './leads.reducer';

export const selectLeadsDataState = createFeatureSelector<LeadsState>('leads');

export const selectLeadsList = createSelector(
  selectLeadsDataState,
  (state: LeadsState) => { console.log('state', state);
   return state.list}
);

export const selectLeadsPagination = createSelector(
  selectLeadsDataState,
  (state: LeadsState) => ({
      pageNumber: state.pageNumber,
      pageSize: state.pageSize,
      totalPages: state.totalPages,
      totalRecords: state.totalRecords
  })
);

export const selectLeadsDataLoading = createSelector(
    selectLeadsDataState,
    (state: LeadsState) => state.loading
);

export const selectLeadsDataError = createSelector(
    selectLeadsDataState,
    (state: LeadsState) => state.error
);
